import React from 'react';
import { logCommonView } from '@/lib/service';
import { EventSource } from '@/shared/constants/event';
import { useConfigProvider, useCreateAccountProvider } from '@/lib/context';
import Image from 'next/image';
import { getCreatorHubSourcingHomePath } from '@/shared/utils/sourcing-marketplace-util';
import { WORK_WITH_FACTORIES_DESCRIPTION } from '@/shared/constants/sourcing-marketplace';
import './index.less';

interface IProps {
  eventContent: string;
}

const RequestRFPButton = ({ eventContent }: IProps) => {
  const { showSignupDialogFromSourcing } = useCreateAccountProvider();
  const { isMobile } = useConfigProvider();

  const handleOnClickRequestRFP = () => {
    logCommonView(EventSource.RFP_STARTED, eventContent);
    showSignupDialogFromSourcing(WORK_WITH_FACTORIES_DESCRIPTION, getCreatorHubSourcingHomePath(), 'rfp');
  };

  return (
    <div className="request-rfp-button" onClick={() => handleOnClickRequestRFP()}>
      <Image className="icon" src="/images/sourcing/rfp.svg" width={8} height={12} alt="request custom project" />
      <span className="text">{isMobile ? 'Custom project request' : 'Post a custom project request'}</span>
    </div>
  );
};

export default RequestRFPButton;
